export const typeList =  [
    {
      name: "联营门店沙龙",
      value: 'union_mec',
    },
    {
      name: "教练沙龙",
      value: 'coach',
    }
  ]
